import PaymentForm from './PaymentForm'

const Create = () => {
    return (
        <PaymentForm
            config={{
                submitSuccessMsg: {
                    header: 'Created',
                    message: 'Payment created successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to create payment',
                },
                saveButton: {
                    label: 'Create',
                    savingLabel: 'Creating payment...',
                },
            }}
        />
    )
}

export default Create
